import styled from "styled-components";

export const Container = styled.div`
    .step-container-three {
        // height: 20em !important;
    }

    .eyePassword{
        background-color: white;
        height: 1em;
        width: 2em;
        margin-left: -2.3em;
        border: none;
    }

    .eyePassword:hover{
        background-color: white;
        height: 1em;
        width: 2em;
        margin-left: -2.3em;
        border: none;
        cursor: pointer;

    }

    button:disabled{
        background-color: var(--primary-color) !important;
    }

    .password-container{
        width: 100%;
        font-size: 14px;
        height: 48px;
        border-radius: 10px;
        margin-top: 0;
    }

    .requirements{
        font-size: 12px;
        color: #5C7199;
        padding-left: 0.4em;
        display: inline-block;

        img {
            height: 12px;
            vertical-align: sub;
        }
    }
    .password-label{
        font-size: 14px;
        font-family: "Inter";
    }

    .SignInLink
    {
        font-family: 'inter';
        font-size: 14px;
        color: var(--primary-color);
        text-align: center;
        a {
            cursor: pointer;
            text-decoration: underline;        
        }
    }
`